import { put, call, select } from "redux-saga/effects";
import {
    fetchSchedulerDefinitions,
    createSchedulerRule,
    updateSchedulerRule,
} from "store/features/emailScheduler/definition/definition.actions";
import emailScheduler, { Exception, SchedulerRuleDefinition } from "api/emailScheduler";
import { resetApiError, riseError } from "store/features/general/general.actions";
import {
    buildEmailSchedulerRuleModel,
    buildSchedulerRuleExceptionViewModel,
} from "api/factories/emailScheduler.factory";
import { getExceptions } from "./definition.selectors";
import { SchedulerExceptionForm } from "validation/components/EmailScheduler/exceptionsFormRules";
import { fetchCreativeMappingsFields } from "../../filters";

export function* fetchEmailSchedulerDefinitionSaga(headers: HeadersInit): Generator {
    const existingExceptions = (yield select(getExceptions)) as SchedulerExceptionForm[];

    try {
        let exceptions;
        const definitions = (yield call(emailScheduler.getSchedulerFilterFields, headers)) as SchedulerRuleDefinition;

        if (!existingExceptions.length) {
            exceptions = (yield call(emailScheduler.getSchedulerRuleExceptions, headers)) as Exception[];
        }

        yield put(fetchCreativeMappingsFields.success({ fields: definitions.fields }));
        yield put(
            fetchSchedulerDefinitions.success({
                ...definitions,
                exceptions: exceptions ? buildSchedulerRuleExceptionViewModel(exceptions) : existingExceptions,
            })
        );
    } catch (err) {
        if (err.status) {
            yield put(fetchSchedulerDefinitions.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* createEmailSchedulerRuleSaga(
    headers: HeadersInit,
    action: ReturnType<typeof createSchedulerRule.request>
): Generator {
    try {
        yield call(emailScheduler.createSchedulerRule, buildEmailSchedulerRuleModel(action.payload), headers);
        yield put(createSchedulerRule.success());
    } catch (err) {
        if (err.status) {
            yield put(createSchedulerRule.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* updateEmailSchedulerRuleSaga(
    headers: HeadersInit,
    action: ReturnType<typeof updateSchedulerRule.request>
): Generator {
    try {
        yield call(
            emailScheduler.updateSchedulerRule,
            buildEmailSchedulerRuleModel(action.payload),
            headers,
            action.payload.id
        );
        yield put(updateSchedulerRule.success());
    } catch (err) {
        if (err.status) {
            yield put(updateSchedulerRule.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
